exports.cs = {
  UNIFORM_DETAIL: {
    INVALID_INPUT: 'Pole není vyplněno správně.',
    ERROR_REQUIRED: 'Zadejte prosím požadované údaje.'
  }
}
